/**
 * AdminPersonaRpcClient - AtomRpc integration for admin persona endpoints
 *
 * This uses AtomRpc.Tag to create a special context tag that provides
 * proper integration with the atom runtime.
 *
 * The ClerkTokenGetter layer reads the `__session` cookie directly (see
 * `readClerkSessionCookieToken`), falling back to `globalThis.__clerkSession`
 * when the cookie isn't present.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminPersonaRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminPersonaRpcClient extends AtomRpc.Tag<AdminPersonaRpcClient>()(
  "AdminPersonaRpcClient",
  {
    group: AdminPersonaRpcs,
    protocol: makeRpcClientLayer(AdminPersonaRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
